export const normalizeNewsSearch = (text: string): string =>
  text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

// The API uses SQL LIKE patterns. Widen Romanian letters, then check the
// actual readable text locally; enumerating every spelling grows exponentially.
export const newsSearchPattern = (query: string): string =>
  normalizeNewsSearch(query)
    .replace(/[\\%_]/g, "\\$&")
    .replace(/[aist]/g, "_");

export const newsContentText = (content: unknown): string => {
  if (typeof content === "string") return content;
  if (Array.isArray(content)) return content.map(newsContentText).join("\n");
  if (content && typeof content === "object") {
    const node = content as { text?: string; children?: unknown };
    if (typeof node.text === "string") return node.text;
    if (node.children) {
      const children = node.children;
      // Inline formatting splits a word across nodes without adding spaces.
      return Array.isArray(children)
        ? children.map(newsContentText).join("")
        : newsContentText(children);
    }
  }
  return "";
};

export const matchesNewsSearch = (
  attributes: { title?: string; content?: unknown; teaser?: unknown },
  query: string,
  searchContent: boolean
): boolean => {
  const fields = searchContent
    ? [attributes.title, newsContentText(attributes.content), newsContentText(attributes.teaser)]
    : [attributes.title];
  const normalizedQuery = normalizeNewsSearch(query);
  return fields.some((field) => normalizeNewsSearch(field ?? "").includes(normalizedQuery));
};
